import cn from 'clsx'
import './MeterStat.scss'
import {Text, Box, InfoTipsIcon} from 'common/components'
import { TipsMark } from './MeterStat.TipsMark'

interface MeterStatProps {
  title: string
  greyTitle?: boolean
  value: string | JSX.Element
  label?: string
  tips?: {
    text: string;
    pos: 'left' | 'right';
  }
  large?: boolean
  type?:
    | 'cyan'
    | 'charcoal'
    | 'stone3'
    | 'green'
    | 'secondGreen'
    | 'darkGreen'
    | 'turquoize'
    | 'lightTurquoize'
    | 'dotsGreen'
    | 'dotsYellow'
    | 'black'
    | 'dotsBlack'
    | 'grey'
    | 'lightGrey'
    | 'transparent'
  right?: boolean
}

const dots = new Array(4).fill('')

export default function MeterStat({
  title,
  greyTitle,
  value,
  label,
  tips,
  large,
  type = 'green',
  right,
}: MeterStatProps) {
  return (
    <div
      className={cn(
        'MeterStat',
        right && 'MeterStat_right',
        `MeterStat_type_${type}`
      )}
    >
      {type.startsWith('dots') ? (
        <div className="MeterStat-Dots">
          {dots.map((_, index) => (
            <div key={index} className="MeterStat-Dot" />
          ))}
        </div>
      ) : (
        <div className="MeterStat-Meter" />
      )}
      <div style={!right ? {}:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}>
          { (tips?.pos === 'left') &&
            <TipsMark $pos={tips.pos}>
              <InfoTipsIcon />
              <div className='tips'>
                <p>{tips.text}</p>
              </div>
            </TipsMark>
          }
          <Text mb={2} color={greyTitle ? 'grey' : undefined}>
            {title}
          </Text>
          { (tips?.pos === 'right') &&
            <TipsMark $pos={tips.pos}>
              <InfoTipsIcon />
              <div className='tips'>
                <p>{tips.text}</p>
              </div>
            </TipsMark>
          }
        </div>
        <Box size={large ? '3xl' : '2xl'} mb={label ? 2 : undefined}>
          {value}
        </Box>
        <Text size="xs" color={!!label ? "grey":"white"}>
          {label || '.'}
        </Text>
      </div>
    </div>
  )
}
